import { apiFetch } from "./apiFetch";

export function updateUserTimezone(timezone) {
  return apiFetch("/users/me/timezone/", {
    method: "PUT",
    body: JSON.stringify({ timezone }),
  });
}

export function fetchTrustBudPreferences() {
  return apiFetch("/users/me/preferences/");
}

export function updateTrustBudPreferences(preferences) {
  return apiFetch("/users/me/preferences/", {
    method: "PUT",
    body: JSON.stringify(preferences),
  });
}

export function fetchSupportProfile() {
  return apiFetch("/intelligence/support-profile/");
}

export function updateSupportProfile(payload) {
  return apiFetch("/intelligence/support-profile/", {
    method: "PUT",
    body: JSON.stringify(payload),
  });
}

export function markWelcomeSeen() {
  return apiFetch("/users/me/welcome/", {
    method: "PUT",
  });
}

export function fetchAccountSettings() {
  return apiFetch("/account-settings/");
}

export function changeAccountPassword(payload) {
  return apiFetch("/account-settings/change-password/", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function deleteAccount() {
  return apiFetch("/account-settings/", {
    method: "DELETE",
  });
}

export async function updateProfileImage(formData) {
  return apiFetch("/account-settings/", {
    method: "PATCH",
    body: formData,
  });
}
